"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableStructure = void 0;
class VariableStructure {
}
exports.VariableStructure = VariableStructure;
VariableStructure.INVOICE_NUMBER = 'invoiceNumber';
VariableStructure.PAYOUT_NUMBER = 'payoutNumber';
VariableStructure.PAYOUT_BATCH_NUMBER = 'payoutBatchNumber';
